const routes = {
    SUBSCRIBE: "/microservice-informed-consent/rest/subscribe",
    UNSUBSCRIBE: "/microservice-informed-consent/rest/unsubscribe",
    CONSULT: "/microservice-informed-consent/rest/consult"
    

}

export default routes;